import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useContactSession } from './ContactSessionProvider';
import { fetchPortalOverview } from '@/lib/api/endpoints/portal';

/** Shared fetch of the portal overview (contact profile + trainer info). All
 *  authed portal pages read from this single query so the data is fetched once. */
export function usePortalOverview() {
  const { workspaceId = '' } = useParams<{ workspaceId: string }>();
  const { token } = useContactSession();
  const query = useQuery({
    queryKey: ['portal-overview', workspaceId],
    queryFn: () => fetchPortalOverview(token!, workspaceId),
    enabled: !!token && !!workspaceId,
    staleTime: 30_000,
  });
  return { ...query, workspaceId, token };
}
